import * as types from './action-types'

export const rehydrationComplete = () => ({ type: types.REHYDRATION_COMPLETE })
